import { GetCountriesData } from '@shared';
import { LatinLettersTooltip } from '../components/addresses/city-select-international/city-select.constants';
import { CountryRecipientPayerConfig, DefaultCountryPhoneConfig } from '../international-invoice.constants';

// Czech Republic
export const CZ: Partial<GetCountriesData> = {
  ...DefaultCountryPhoneConfig,
  ...CountryRecipientPayerConfig,
  CityTooltip: LatinLettersTooltip,
  RecipientPostboxAvailable: true,
  RecipientSpotSelectionAvailable: true,
  RecipientPayerAllowed: true,
};
